import { Phone, MessageCircle } from "lucide-react";

export default function FloatingCTA({ contact }) {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3" data-testid="floating-cta">
      <a data-testid="floating-whatsapp-button" href={`https://wa.me/${contact.whatsapp}?text=Hi%20AZ%20Concepts%2C%20I%27d%20like%20a%20wholesale%20quote.`}
        target="_blank" rel="noreferrer" aria-label="Chat on WhatsApp"
        className="h-14 w-14 rounded-full bg-[#25D366] hover:bg-[#1eb856] flex items-center justify-center shadow-lg shadow-black/40 hover:scale-110 transition-transform">
        <MessageCircle size={24} className="text-white" />
      </a>
      <a data-testid="floating-call-button" href={`tel:${contact.phone}`} aria-label="Call AZ Concepts"
        className="h-14 w-14 rounded-full bg-[#FF5A1F] hover:bg-[#E04810] flex items-center justify-center shadow-lg shadow-black/40 hover:scale-110 transition-transform">
        <Phone size={24} className="text-white" />
      </a>
    </div>
  );
}
